<template>
  <div>
    <div
      class="demo__flex demo__margin-bottom--24"
      v-bind:class="{
        'demo__flex-middle': !isMobile,
        'demo__flex-column': isMobile,
      }"
    >
      <div
        class="demo__font--20 demo__weight--600 demo__color--black demo__margin-right--16"
      >
        {{ $t("Reg for users " + step) }}
      </div>
      <div
        class="demo__font--11 demo__weight--500 demo__color--textPrimaryGray"
        v-bind:class="{
          'demo__margin-top--8': isMobile,
        }"
      >
        {{ $t("Step") }} {{ step }} {{ $t("from") }} {{ maxStepsCount }}
      </div>
    </div>
    <component :is="'Step' + step" :form="form" :reg-result="regResult" />
  </div>
</template>

<script>
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

import { mapGetters } from "vuex";

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      regResult: undefined,
      step: 1,
      maxStepsCount: 3,
      form: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        username: undefined,
        phone: " ",
        password: undefined,
        promo: undefined,
        invitation: undefined,
      },
    };
  },
  computed: {
    ...mapGetters(["api", "isMobile"]),
  },
  beforeDestroy() {
    this.$root.$off("changeRegStep", this.changeRegStep);
    this.$root.$off("regFinish", this.register);
  },
  created() {
    this.$accessModule("reg", this);
    this.$root.$on("changeRegStep", this.changeRegStep);
    this.$root.$on("regFinish", this.register);
  },
  methods: {
    changeRegStep(step) {
      if (step >= 1 && step <= this.maxStepsCount) {
        this.step = step;
      }
    },
    loginAfterRegister() {
      this.api
        .auth({
          data: {
            username: this.form.username,
            password: this.form.password,
          },
        })
        .then((response) => {
          if (response.data.token) {
            this.$store.dispatch("updateToken", response.data.token);
            this.$root.getUserInfo();
            this.$root.$emit("startUserUpdate");

            this.$store.dispatch("updateAuthModalStatus", false);

            this.$debug("Успешная авторизация", "success", response.data);
          } else {
            throw response.data;
          }
        })
        .catch(() => {
          this.$store.dispatch("updateAuthModalStatus", "Login");
          this.$notify({
            group: "loggedIn",
            type: "error",
            text: this.$t("Auth error unknown"),
          });
        });
    },
    register() {
      this.form.username = this.form.email;
      this.form.phone = this.form.phone.replaceAll(" ", "");
      this.api
        .register({
          data: this.form,
        })
        .then((response) => {
          this.$debug("Успешная регистрация", "success", response.data);
          this.loginAfterRegister();
        })
        .catch((error) => {
          const error_message = error.message;

          let text;

          switch (error_message) {
            case "Network Error":
              text = this.$t("Auth error network");
              break;

            case "Request failed with status code 400":
              text = this.$t("Reg error 400");
              break;

            default:
              text = this.$t("Reg error");
              break;
          }

          this.$debug("Ошибка регистрации " + text, "error", error_message);

          //TODO обсудить список ошибок
          this.regResult = text;
          // this.$root.$emit("changeRegStep", 1);
        });
    },
  },
};
</script>
